import React, { Component } from 'react'
import { getUser } from '../../../actions/session';
import axios from 'axios';
import { Notifications } from '../../common/notification';
import { CALL_LOG_LISTING, LOGIN_URL } from '../../../config/rest_endpoints';
import CustomLoader from '../../common/loader';
import Select from 'react-select';
import Pagination from "react-js-pagination";
import { RC_LOAD_LOGIN } from '../../routers/RouteConstants';
import { withRouter } from 'react-router-dom';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

var firstDate = new Date();
const startT = moment(firstDate.getTime()).subtract(10, 'm')

class CallLogs extends Component {
    constructor(props) {
        super(props)
        // initializing states
        this.state = {
            User: getUser(),
            logData: [],
            startDate: startT,
            endDate: moment(new Date()),
            userNumber: this.props.userNumber,
            userId: this.props.userId,
            isGetting: false,
            selectedtype: 'all',
            callTypes: [
                { value: 'all', label: 'All' },
                { value: 'successful', label: 'Successfull' },
                { value: 'failed', label: 'Failed' }
            ],
            msg: '',
            activePage: 1,
            itemsCount: 10,
            totalCount: null,
            searchValue: '',
            isCallIdLong:false

        }
        this.clearFilter = this.clearFilter.bind(this)
        this.handleCallType = this.handleCallType.bind(this)
        this.callLogListing = this.callLogListing.bind(this)
        this.searchSpace = this.searchSpace.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.textShortness = this.textShortness.bind(this)
    }

    componentDidMount() {
        this.callLogListing()
    }

    handleCallType(selectedtype) {
        this.setState({ selectedtype })
    }

    searchSpace(e) {
        this.setState({ searchValue: e.target.value }, () => { this.callLogListing() })
    }

    // handle date and time on selection of datetime picker
    handleDate(date, value) {
        if (value == "start") {
            this.setState({ startDate: date }, () => {
                console.log('start', this.state.startDate);
            })
        } else {
            this.setState({ endDate: date }, () => {
                console.log('end', this.state.endDate);
            })
        }
    }

    clearFilter() {
        this.setState({
            searchValue: '',
            selectedtype: 'all'
        }, () => {
            this.callLogListing()
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.callLogListing()
        });
    }

    callLogListing() {
        const { userNumber, User, selectedtype, activePage, itemsCount, searchValue, userId, startDate, endDate } = this.state
        console.log('userId', userId)
        var SelectType = selectedtype.value
        var searchNumber = searchValue
        // var payload = {
        //     "data": {
        //         "start": Math.floor(startDate.getTime() / 1000.0),
        //         "end": Math.floor(endDate.getTime() / 1000.0)
        //     },
        //     "fields": [
        //         {
        //             "destination": searchValue
        //         }
        //     ]
        // }
        var payload = {
                    "startDate": Math.floor(startDate.toDate().getTime() / 1000.0),
                    "endDate": Math.floor(endDate.toDate().getTime() / 1000.0)
           
        }
        this.setState({ isGetting: true })
        var headers = { "Authorization": "Bearer " + User.token };
        axios.post(`${CALL_LOG_LISTING}/${userId}/billing/reports/cdrs?page=${activePage}&limit=${itemsCount}`, payload, { headers }).then(res => {
            console.log('res', res)
            console.log('data', res.data.data)
            if (res.data === "" ) {

                this.setState({
                isGetting: false,
                logData: [],
            })
            }
            else{
                this.setState({
                    logData: res.data.data,
                    isGetting: false,
                    msg: res.data.message,
                    totalCount: res.data.pageinfo.totalCount
                })
            }
            
            // Notifications.notify(this.state.msg, "Fetched", "success")
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })

        })
        console.log('searchNumber :', searchNumber);
    }

    textShortness(row) {
        const {isCallIdLong } = this.state
        var rowId = row['callID']
        console.log('rowId', rowId)
        this.setState({
           isCallIdLong: !isCallIdLong,
        })
    }

    renderCallLogs() {
        const { logData, searchValue,isCallIdLong } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        if (!logData.length || logData === null) {
            return nullData
        }
        else {
            return logData.map((row, idx) => {
                return (
                    <tr key={idx} >
                        <td style={{textAlign:'center'}}>{row.setupTime}</td>
                        <td style={{textAlign:'center'}}>{row.answerTime}</td>
                        <td style={{textAlign:'center'}}>{isCallIdLong ?row.callID :row.callID.substring(0,8) }<i className="icon-menu ml-1" onClick={this.textShortness.bind(this,row)} style={{cursor:'pointer'}}></i></td>
                        <td style={{textAlign:'center'}}>{row.source}</td>
                        <td style={{textAlign:'center'}}>{row.destination}</td>
                        {/* <td>{row.accountType}</td> */}
                        <td style={{textAlign:'center'}}>{row.duration}</td>
                        <td style={{textAlign:'center'}}>{row['RPM']}</td>
                        <td style={{textAlign:'center'}}>{row.hangupCode}</td>
                        <td style={{textAlign:'center'}}>{row.hangupCause}</td>
                        <td style={{textAlign:'center'}}>{row.customerIP}</td>
                        {/* <td>{row.carrier}</td> */}
                        {/* <td>{row.state}</td> */}
                        <td style={{textAlign:'center'}}>{row.billed}</td>
                        {/* <td>{row.balance}</td> */}
                        {/* <td>{row.paid}</td> */}
                        {/* <td>{row.profit}</td> */}
                    </tr>
                )
            })
        }

    }

    render() {
        const { isGetting, callTypes, selectedtype, activePage, itemsCount, totalCount, startDate, endDate, searchValue } = this.state
        return (
            <div>
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2">
                        <div class="py-2 px-3 mb-1 rounded-left">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Start Date</label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "start")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }}
                                >
                                <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        <div class="py-2 px-3 mb-1">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">End Date</label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "end")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }}
                                >
                                <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        <div class="py-2 px-3 mb-1 rounded-right">
                            <div className="" style={{ marginLeft: '4px', marginTop: '2.4em' }}>
                                <button type="submit" className="main-button btn btn-sm btn-success" onClick={this.callLogListing} >Filter Date <i class="icon-calendar22 ml-2"></i></button>
                            </div>
                        </div>
                    </div>
                    {/* row 1 */}
                    <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-4">
                        <div class=" py-2 px-3 mb-1">
                            <div className=" ">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Search Destination</label>
                                <div class="input-group w-27em">
                                    <input type="text" class="form-control " value={searchValue} onChange={this.searchSpace} placeholder="Type number" />
                                </div>
                            </div>
                        </div>
                        <div class=" py-2 px-3 mb-1">
                            <div className="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14 ">Call Type</label>
                                <Select
                                    value={selectedtype}
                                    onChange={this.handleCallType}
                                    options={callTypes}
                                    className="w-27em"
                                />
                            </div>
                        </div>
                        <div class="py-2 px-3 mb-1">
                            <div className="" style={{ marginLeft: '4px', marginTop: '2.4em'  }}>
                                <button type="submit" className="main-button btn btn-primary btn-sm" onClick={this.getCallLog} >Filter Type <i class="icon-paperplane ml-2"></i></button>
                            </div>
                        </div>
                    </div>

                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">

                        <div className="datatable-scroll" style={{ overflowX: 'auto' }}>
                            <table style={{border:'1px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Start Time</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Answer Time</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Call ID</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Source</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Destination</th>
                                        {/* <th>Account Type</th> */}
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Duration</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>RPM</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Hangup Code</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Hangup Reason</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Source IP</th>
                                        {/* <th>Carrier</th> */}
                                        {/* <th>State</th> */}
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Billed</th>
                                        {/* <th>Balance</th>
                                        <th>Paid</th>
                                        <th>Profit</th> */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderCallLogs()}
                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer mt-1 border-top">
                            <div className="mt-3">
                                <Pagination
                                    activePage={activePage}
                                    itemsCountPerPage={itemsCount}
                                    totalItemsCount={totalCount}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(CallLogs)